// @ts-nocheck
/* eslint-enable */
// App
import React from 'react';
import { useSelector } from 'react-redux';

// Components
import SharedMarketingBlurb from 'app/shared/modules/MobileSRP/SeoFooter/MarketingBlurb';
import SrpContentWrapper from 'app/shared/modules/MobileSRP/__BaseComponents__/SrpContentWrapper';
import MobileLinkGroup from 'app/shared/modules/navigation/footer/SeoFooter/MobileLinkGroup';

// Misc / utils
import searchSlugUtils from 'app/shared/utils/searchSlugUtils';
import * as S from './styles';

const SeoFooter = () => {
  // Redux
  const seoLinks = useSelector((state) => state.seo.seoFooterLinks);
  const pathname = useSelector((state) => state.location.current.pathname);
  const slug = searchSlugUtils.getSearchSlugFromUrl(pathname);
  const shouldShowMarketingBlurb = slug === 'apartments-for-rent' || slug === 'houses-for-rent';

  return (
    <SrpContentWrapper
      identifier="seo-footer"
      customHeader={
        shouldShowMarketingBlurb ? (
          <header>
            <SharedMarketingBlurb />
          </header>
        ) : null
      }
      background="backgroundGrey"
      fluid
      border="borderTop"
    >
      {shouldShowMarketingBlurb ? <S.SemanticDivider /> : null}
      <ul>
        {seoLinks.groups &&
          seoLinks.groups.map((group) => {
            const hasLinks = group.links.length > 0;

            if (!hasLinks) {
              return null;
            }

            return (
              hasLinks && (
                <MobileLinkGroup
                  header={group.header}
                  links={group.links}
                  key={`seo-footer-mobile-link-group-${group.header}`}
                />
              )
            );
          })}
      </ul>
    </SrpContentWrapper>
  );
};

export default SeoFooter;
